import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AuthService } from './core/auth.service';
import { MixpanelService } from './shared/mixpanel.service';
import { RoutingstateService } from './shared/routingstate.service';

declare const ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(public router: Router, private auth: AuthService, private routingstate: RoutingstateService, private mixpanel: MixpanelService) {
    this.routingstate.loadRouting();
  }

  async ngOnInit() {
    // init mixpanel early to prevent any race condition
    this.mixpanel.init();
    try {
      const loggedIn = await this.auth.hasSessionP();
      if (!loggedIn) {
        throw new Error('User not logged in');
      }
      const clientGroup = this.auth.getClientGroupFromToken();
      await this.auth.fetchPasswordExpiryDays(clientGroup);

      this.auth.afterValidSession();
      this.setupGATracking();
    } catch (error) {
      console.error(error.message); // only to catch and log "user not logged in error"
    }
  }

  // listen for special key events to toggle dev mode
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    const mKey = 77;

    if (event.ctrlKey && event.shiftKey && event.keyCode === mKey) {
      this.auth.toggleDevMode();
    }
  }

  setupGATracking() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/app.component.ts